import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import '../App.css'
import ReuseSidebar from './ReuseSidebar'


const Navbar = ({ openSidebar,  }) => {
  const[searchTerm, setSearchTerm]=useState('')
  const navigate=useNavigate()

  const handleSubmit=(e)=>{
    e.preventDefault();
    if(searchTerm){
        navigate(`/search/${searchTerm}`)
        setSearchTerm('');
    }

  }

  return (
    <>

      <div className="container-fluid bg-light sticky-top">
        <div className="row ">
          <div className=" my-2 col hstack ">
              <i className="fa-solid fa-bars fs-3 align-self-center d-none d-sm-block " onClick={openSidebar}></i>
              {/*-----------------------------this--------*/}
              <button className="btn d-block d-sm-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
              <i className="fa-solid fa-bars fs-3 align-self-center " ></i>
</button>

<div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel" style={{width:"200px"}}>
  <div className="offcanvas-header">
    <div className="offcanvas-title d-flex" id="offcanvasExampleLabel">
    <i className="fa-brands mx-2 mt-1 mt-sm-1 mt-md-2 text-danger fa-youtube"></i>
    <h5 className='   text-danger'>Youtube</h5>
    </div>
    <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div className="offcanvas-body">
    <div>
     <ReuseSidebar/>
    </div>
    
  </div>
</div>
              {/*-----------------------------this--------*/}
              <i className="fa-brands px-2 fs-3 ps-2 ps-sm-2 ps-md-4 ps-lg-5 text-danger fa-youtube"></i>
              <h4 className='   text-danger 	d-none d-sm-block  	d-sm-none d-md-block'>Youtube</h4>
              
              <form action="" className='col-5  hstack  position-relative mx-auto ' onSubmit={handleSubmit}>
                <input type="text" id="NavbarInputOne" value={searchTerm} className='form-control   rounded-pill rounded-0' placeholder='Search' onChange={(e)=>setSearchTerm(e.target.value)} />
               <label htmlFor="NavbarInputOne ">
                <span className=''>
                <i className="fa-solid fa-magnifying-glass position-absolute top-0 end-0 text-danger pe-3  mx-4 mx-sm-4 mx-md-5 mx-lg-5"></i>
                </span>
               </label>
               <i className="fa-solid fa-microphone fs-5 ms-2"></i>
              </form>
              
           

             
           
          </div>
        </div>
      </div>

    </>
  )
}

export default Navbar


